var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLineStyleDotted = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.25 8C4.25 7.58579 3.91421 7.25 3.5 7.25H2C1.58579 7.25 1.25 7.58579 1.25 8C1.25 8.41421 1.58579 8.75 2 8.75H3.5C3.91421 8.75 4.25 8.41421 4.25 8ZM11.75 8C11.75 7.58579 12.0858 7.25 12.5 7.25H14C14.4142 7.25 14.75 7.58579 14.75 8C14.75 8.41421 14.4142 8.75 14 8.75H12.5C12.0858 8.75 11.75 8.41421 11.75 8ZM7.25 7.25C6.83579 7.25 6.5 7.58579 6.5 8C6.5 8.41421 6.83579 8.75 7.25 8.75H8.75C9.16421 8.75 9.5 8.41421 9.5 8C9.5 7.58579 9.16421 7.25 8.75 7.25H7.25Z",
  fill: "currentcolor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLineStyleDotted);
export default ForwardRef;